// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8406":"css/app.6790","8807":"css/admin-app.6790"}[chunkId] + ".css";
};